
import api from '@/axios/api';
import {
  defineAsyncComponent, defineComponent, reactive, toRefs, PropType, watch, ref, SetupContext,
} from 'vue';
import { useRouter } from 'vue-router';
import { Spin } from 'ant-design-vue';
import { ClassJobBasicInfoI, JobBasicInfoI } from '@/views/Teacher/addJob/js/interface';// '../addJob/js/interface';
import { apiQueryData } from '@/views/Teacher/addJob/js/jobBasicInfo';// '../addJob/js/jobBasicInfo';
// import { getPreviewData, transQuestionData } from '@/views/Teacher/caseAnalysis/js/jobPreview';// './js/jobPreview';

/** 路由接受两个参数
 * analysisId 案例分析的id-用来查案例数据
 * view preview,see,submit
 *    - preview-教师预览-无数据-教师预览显示正确答案、
 *    - see-查看-有数据-显示学生答案、
 *    - submit-答题-只显示题目，不显示答案、
 */
export default defineComponent({
  components: {
    analysisHeader: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/analysisHeader.vue')),
    questionModules: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/questionModule.vue')),
    aSpin: Spin,
  },
  props: {
    /** 案例分析id */
    jobId: {
      type: String,
    },
    /** loading */
    questionLoading: {
      type: Boolean,
    },
    /** 模式 */
    view: {
      type: String as PropType<'preview'|'see'|'submit'>,
      required: true,
    },
  },
  emits: ['handle-submit'],
  setup(props, ctx: SetupContext) {
    const router = useRouter();
    const analysis = reactive<JobBasicInfoI>(new ClassJobBasicInfoI()); // 案例分析详情
    const { questionLoading: qLoading, view: jobView } = toRefs(props);
    const basicLoading = ref(false);

    const initInfo = async () => {
      basicLoading.value = true;
      const { data } = await api.queryCustomCaseAssignmentById(props.jobId as string);
      Object.assign(analysis, apiQueryData(data.data));
      basicLoading.value = false;
    };

    const goBack = () => {
      router.back();
    };

    const onSubmit = () => {
      ctx.emit('handle-submit');
    };

    watch(() => props.jobId, (newV) => {
      if (newV) {
        initInfo();
      }
    }, { immediate: true, deep: true });
    return {
      // loadign
      qLoading,
      basicLoading,
      // data
      analysis,
      jobView,
      // method
      goBack,
      onSubmit,
      // initQuestion,
    };
  },
});
